import { Tooltip } from "@mui/material";
import Restaurant from "@mui/icons-material/Restaurant";
import AppStateContext from "contexts/AppStateContext";
import { FunctionComponent, useContext } from "react";

type Props = {
  active: boolean;
  showLabel?: boolean;
};

const FoodIndustryIcon: FunctionComponent<Props> = ({
  active,
  showLabel = false,
}) => {
  const { strings } = useContext(AppStateContext);
  return (
    <Tooltip title={strings.FoodIndustry}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: "0.2rem" }}>
        <Restaurant
          sx={{
            fontSize: "1.4em",
            verticalAlign: "middle",
            color: active ? "green" : "lightgrey",
          }}
        />
        {showLabel && active && (
          <span style={{ fontSize: "0.85em" }}>{strings.FoodIndustry}</span>
        )}
      </span>
    </Tooltip>
  );
};

export default FoodIndustryIcon;
